import * as _ from "lodash-es";
import axios from "axios";
import { notifyAxiosError } from "@/notify";
import { MAX_PAGE_SIZE } from "@/constants";

export default {
  namespaced: true,
  state: {
    leadReferencesMap: {},
    isLeadReferencesFetching: false,
    isLeadReferencesFetched: false,
  },
  mutations: {
    setLeadReferences: function (state, leadReferences) {
      state.leadReferencesMap = _.keyBy(leadReferences, "id");
    },
    setLeadReferencesFetching: function (state, isLeadReferencesFetching) {
      state.isLeadReferencesFetching = isLeadReferencesFetching;
    },
    setLeadReferencesFetched: function (state, isLeadReferencesFetched) {
      state.isLeadReferencesFetched = isLeadReferencesFetched;
    },
    updateLeadReference: function (state, leadReference) {
      state.leadReferencesMap = {
        ...state.leadReferencesMap,
        [leadReference.id]: leadReference,
      };
    },
  },
  getters: {
    leadReferencesList(state) {
      return _.sortBy(Object.values(state.leadReferencesMap), "name");
    },
    leadReferencesOptions(state, getters) {
      return getters.leadReferencesList.map((r) => ({ value: r.id, text: r.name }));
    },
  },
  actions: {
    fetchLeadReferences(context) {
      if (
        context.state.isLeadReferencesFetching ||
        context.state.isLeadReferencesFetched
      ) {
        return;
      }
      context.commit("setLeadReferencesFetching", true);
      return axios
        .get("/lead-references/", { params: { page_size: MAX_PAGE_SIZE } })
        .then(
          (response) => {
            context.commit("setLeadReferencesFetching", false);
            context.commit("setLeadReferencesFetched", true);
            context.commit("setLeadReferences", response.data.results);
          },
          (error) => {
            context.commit("setLeadReferencesFetching", false);
            notifyAxiosError(error);
          },
        );
    },
  },
};
